'use strict';
var parent = require('../../stable/instance/for-each');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/instance/for-each.js
// module id = 532
// module chunks = 13